import WellnessCheckService from 'src/modules/wellnessCheck/wellnessCheckService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'WELLNESS_CHECK_VIEW';

const wellnessCheckViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: wellnessCheckViewActions.FIND_STARTED,
      });

      const record = await WellnessCheckService.find(id);

      dispatch({
        type: wellnessCheckViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: wellnessCheckViewActions.FIND_ERROR,
      });

      getHistory().push('/wellness-check');
    }
  },
};

export default wellnessCheckViewActions;
